import { SUCCESS } from "../../../../constants/action-postfix";
import { PERFORMANCE_REQUEST } from "../performanceReducer";


const initialState = null;

export const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${PERFORMANCE_REQUEST}${SUCCESS}`:
            return action.payload;
        default:
            return state;
    }
};
